<template>
  <div class="section">
    <div class="section-header">
      <h5>Recepciones</h5>
    </div>

    <div class="container-skeleton-card" v-if="loading_asn_status">
      <div v-for="n in 3" :key="n" class="skeleton-card-loader">
        <v-skeleton-loader class="skeleton-card-loader" type="card"></v-skeleton-loader>
      </div>
    </div>
    <div class="status-cards" v-else>
      <div
        v-for="state in status_reception.filter(s => s.id_state !== 'REC')"
        :key="state.id_state"
        class="status-card"
        :class="'status-' + state.id_state"
      >
        <div class="status-info">
          <div class="status-name">{{ state.state }}</div>
          <div class="status-count">{{ state.amount }}</div>
        </div>
      </div>
    </div>

    <div class="section-header mb-2 mt-4">
      <div>
        <h6 class="mb-0">Recepciones activas</h6>
        <p class="text-caption text-grey mb-0">Últimos 30 días · excluye cerradas y completamente almacenadas</p>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="asns"
      :loading="loading_asn_today"
      loading-text="Cargando..."
    >
      <template v-slot:item="{ item }">
        <tr :class="'status-' + (item.status?.id || item.status)">
          <td>{{ item.id }}</td>
          <td>{{ formatDate(item.estimated_arrival_date) }}</td>
          <td>{{ item.client_username }}</td>
          <td>
            {{ item.document_type_name ?? "-" }}<br />
            <span v-if="item.external_reference" class="table-text-secondary">Ref: {{ item.external_reference }}</span>
          </td>
          <td>
            <div class="status-badge font-weight-medium" :class="'status-' + (item.status.id || item.status)">
              {{ asnService.getStatusName(item.status) }}
              <p class="text-caption text-grey-600 mb-0" v-if="item.sub_status">
                {{ asnService.getSubStatusName(item.sub_status) }}
              </p>
            </div>
          </td>
          <td class="d-flex align-center" style="min-width: 180px">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :class="'progress-' + item.status"
                :style="{ width: getProgresoRecepcion(item) + '%' }"
              ></div>
            </div>
            <span class="progress-text">{{ getProgresoRecepcion(item) }}%</span>
          </td>
          <td>
            <span v-if="item.storage_progress === 100" class="text-success">Almacenado</span>
            <div v-else-if="item.storage_progress > 0" class="d-flex align-center" style="min-width:120px">
              <div class="progress-bar">
                <div class="progress-fill progress-storing" :style="{ width: item.storage_progress + '%' }"></div>
              </div>
              <span class="progress-text">{{ item.storage_progress }}%</span>
            </div>
            <span v-else class="text-grey">-</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { asnService } from "@/libs/ws/asnService";

export default {
  props: {
    status_reception: { type: Array, default: () => [] },
    loading_asn_status: { type: Boolean, default: false },
    asns: { type: Array, default: () => [] },
    loading_asn_today: { type: Boolean, default: false },
  },
  data() {
    return {
      asnService,
      headers: [
        { title: "ASN",              align: "left", sortable: true,  key: "id" },
        { title: "Fecha",            align: "left", sortable: true,  key: "estimated_arrival_date" },
        { title: "Cliente",          align: "left", sortable: true,  key: "client_username" },
        { title: "Documento / Ref.", align: "left", sortable: false, key: "document_type_name" },
        { title: "Estado",           align: "left", sortable: true,  key: "status" },
        { title: "Recepción",        align: "left", sortable: false, key: "progress" },
        { title: "Almacenamiento",   align: "left", sortable: false, key: "storage" },
      ],
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      return d.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    getProgresoRecepcion(item) {
      if (!item.total_expected_amount || item.total_expected_amount === 0) return 0;
      if (item.status === asnService.STATE_CERRADO) return 100;
      return Math.min(100, Math.round((item.base_amount_received / item.total_expected_amount) * 100));
    },

  },
};
</script>
